import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import React, { Fragment } from 'react';

type Props = {
  isMobile: boolean;
};

const NftRightDetailsSkeleton: React.FC<Props> = ({ isMobile }) => {
  return (
    <Fragment>
      {isMobile && (
        <Stack
          mb={4}
          height={'528px'}
          alignItems="center"
          justifyContent="center"
          bgcolor="#1A1A1A"
          borderRadius="12px"
          position="relative"
          overflow="hidden"
        >
          {/* Skeleton for NFT preview image */}
          <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            sx={{ position: 'absolute', bottom: '10px', right: '10px', borderRadius: '30%' }}
          />

          {/* Skeleton for main NFT image */}
          <Skeleton variant="rectangular" width={256} height={144} sx={{ borderRadius: '6px' }} />
        </Stack>
      )}
      <Box mb={3}>
        <Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={48} sx={{ mb: 2 }} />
        <Stack direction="row" alignItems="center" display={'none'}>
          <Skeleton width={24} height={24} sx={{ mr: 1 }} />
          <Skeleton variant="text" width="30%" height={20} />
        </Stack>
      </Box>

      <Box borderTop="1px solid #54585F" mb={1}>
        <Skeleton height={40} sx={{ marginBottom: '0', padding: '16px 0' }} />
      </Box>

      <Box borderTop="1px solid #54585F" mb={3}>
        <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
        <Stack direction="row" alignItems="baseline">
          <Skeleton variant="text" width="20%" height={38} />
          <Skeleton variant="text" width="15%" height={16} sx={{ ml: 3 }} />
        </Stack>
        <Stack spacing={2} mt={2}>
          <Skeleton variant="text" width="20%" height={32} sx={{ mt: 3 }} />
          <Button
            variant="contained"
            fullWidth
            disabled
            sx={{
              textTransform: 'none',
              color: '#000',
              backgroundColor: '#fff',
              width: '200px',
              fontSize: '16px',
              padding: '16px'
            }}
          >
            <Skeleton variant="text" width="80%" height={20} />
          </Button>
        </Stack>
      </Box>

      <Box borderTop="1px solid #54585F" mb={3}>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="primary" />}
            aria-controls="panel-content"
            id="panel-header"
            sx={{ display: 'flex', alignItems: 'center', padding: 0 }}
          >
            <Skeleton variant="text" width="20%" height={20} />
          </AccordionSummary>
          <AccordionDetails sx={{ textAlign: 'left', padding: 0 }}>
            <Skeleton variant="text" width="100%" height={24} />
            <Skeleton variant="text" width="90%" height={24} sx={{ mt: 1 }} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Fragment>
  );
};

export default NftRightDetailsSkeleton;
